module.exports = __webpack_public_path__ + "media/images/expert__david-lemos-5433ea7188f71f83840a81e18681cde8.png";